import React, { useState } from 'react'
import { Wrapper, Container } from './WebStyle'
import styled from 'styled-components'
import { CreateButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
import { useTypedSelector } from 'src/redux/root-reducer'
import { addNairaSign } from 'src/utils/addNairaSign'
import { trophy } from 'src/assets'
import { PlanNameModal } from 'src/components/HomePage/ModalsContent/createPlans/plans-redux-modal/PlanName'
import NoPlan from './EmptyPlan/NoPlan'
import { GeneralTitle } from 'src/components/Global/Text/TitleText'

const Progress = styled.div<{
  width?: any
}>`
  width: ${(props) => (props.width ? props.width : '10%')};
  background-color: ${({ theme }) => theme.colors.secondPrimary};
  color: ${({ theme }) => theme.colors.secondPrimary};
  opacity: 1;
  height: 5px;
`
const WebTransaction = ({ width }: any) => {
  const [showModal, setShowModal] = useState(false)

  const myPlans = useTypedSelector(
    (state) => state.userPlanReducer.myPlans?.plans
  )

  const myGeneralPlans = myPlans?.filter((el: any) => {
    return el.plan_type === 'general'
  })

  let location = useLocation()
  const createPlan = (e: any) => {
    e.preventDefault()
    setShowModal(true)
  }

  const [id, setId] = useState()
  return (
    <Wrapper>
      <CreateButton onClick={createPlan} className="create">
        Create
      </CreateButton>
      <Container>
        {/* <CreateButton onClick={createPlan}>Create</CreateButton> */}
        <PlanNameModal showModal={showModal} setShowModal={setShowModal} />
        <div className="heading">
          <GeneralTitle>My Plans</GeneralTitle>
        </div>

        {myGeneralPlans?.length === 0 && (
          <NoPlan children="No General Savings. Save now!" />
        )}

        {myGeneralPlans?.map(
          ({
            accrued_interest,
            balance,
            name,
            id,
            index,
            progress_percent,
          }: any) => {
            return (
              <Link
                to={`/plan-detail/${id}`}
                key={index}
                state={{ backgroundLocation: location }}
              >
                <div
                  className="plans"
                  key={index}
                  onClick={(e) => {
                    setId(id)
                  }}
                >
                  <div className="">
                    <img src={trophy} alt="trophy" />
                  </div>
                  <div className="info">
                    <h3 className="description">{name}</h3>
                    <p className="amount">{addNairaSign(balance)}</p>
                    <div className="slider">
                      <Progress
                        width={
                          progress_percent >= '100'
                            ? '100%'
                            : `${progress_percent}%`
                        }
                      />
                      <div className="notProgress"></div>
                    </div>
                  </div>
                </div>
              </Link>
            )
          }
        )}
      </Container>
    </Wrapper>
  )
}

export { WebTransaction }
